import { UiCheckCircleIcon } from "@jti/brand-icons/ui-check-circle";
import { useTranslations } from "@jti/ui";

import { ItemFlag } from "@checkout/components/CartItem/ItemFlag/ItemFlag";

export const ConsentItemFlag = () => {
  const { __ } = useTranslations();

  return <ItemFlag icon={UiCheckCircleIcon} text={__("cart.cart_item.consent_information")} />;
};
